import { Box, Image } from "@chakra-ui/react";
import lantern from "../images/lantern.png";

/**
 * @description 燈籠裝飾元件(單個)
 * @returns {JSX.Element}
 */
const Lantern = () => {
  return (
    <Box
      pointerEvents={"none"}
      right={"-11rem"}
      bottom={"-12rem"}
      position={"fixed"}
      display={{ base: "none", xl: "block" }}
    >
      <Image src={lantern} alt="New Year Lantern" transform={"scale(0.5)"} />
    </Box>
  );
};
export default Lantern;
